import { render, staticRenderFns } from "./commoditymodel.vue?vue&type=template&id=a552df96&scoped=true&"
import script from "./commoditymodel.vue?vue&type=script&lang=js&"
export * from "./commoditymodel.vue?vue&type=script&lang=js&"
import style0 from "./commoditymodel.vue?vue&type=style&index=0&id=a552df96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a552df96",
  null
  
)

export default component.exports